import type { EmployeeStatus } from '@Common/types/bo/b2b/employees_properties';

const EMPLOYEE_STATUS_RANK: Record<EmployeeStatus, number> = {
  current: 0,
  retired: 1,
  past: 2,
};

export type EmployeeEmploymentIdentity = {
  id: number;
  status: EmployeeStatus;
  isClosedOrArchived?: boolean;
};

/**
 * Prefer a non-closed/archived user over a closed/archived one first (a closed duplicate must
 * never block a campaign for the still-valid employee), then current > retired > past when
 * several employees share an identifier (e.g. rehire). Same status → higher id (newer row).
 */
export function shouldPreferEmployeeByEmploymentStatus(
  candidate: EmployeeEmploymentIdentity,
  existing: EmployeeEmploymentIdentity,
): boolean {
  const candidateClosed = candidate.isClosedOrArchived ?? false;
  const existingClosed = existing.isClosedOrArchived ?? false;
  if (candidateClosed !== existingClosed) {
    return !candidateClosed;
  }

  const candidateRank = EMPLOYEE_STATUS_RANK[candidate.status];
  const existingRank = EMPLOYEE_STATUS_RANK[existing.status];
  if (candidateRank !== existingRank) {
    return candidateRank < existingRank;
  }
  return candidate.id > existing.id;
}
